import React, { useState, useEffect } from "react";

import { FormControlLabel, Switch } from "@mui/material";
import Feedback from "./Feedback";
import Information from "./Information";
import UserMenu from "./UserMenu";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";



function Header({
  activeTab,
  handleTabChange,
  toggleMenu,
  isMenuOpen,
  handleLogout,
  geocoderContainerRef,
  showSearch = false,
  showFavorites = false,
  showLinks = false,
  handleUpgrade,
  isSubscribed = false,
  // County selector props
  selectedCounty,
  countiesList = [],
  onCountyChange,
  showCountySelector = false,
  onParcelSearch,
  clearParcelSearch,
  setIsParcelSearchActive,
 resetParcelSearchSignal = null,
  onAdjacentToggle,
  isAdjacentMode = null,
}) {
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const storedName = localStorage.getItem('name') || 'User';
  const storedEmail = localStorage.getItem('email') || 'unknown';

  const [showParcelSearch, setShowParcelSearch] = useState(false);
  const [parcelInput, setParcelInput] = useState("");
  const [parcelError, setParcelError] = useState("");
  const prevLengthRef = React.useRef(0);
  const [isParcelValid, setIsParcelValid] = useState(false);
  // const [isParcelSearchActive, setIsParcelSearchActive] = useState(false);

  // Upgrade button handler
  const handleUpgrade1 = () => {
    // navigate('/stripe-integration');
    navigate("/pricing");
    // navigate('/payment');
    // navigate('/stripe');

    // navigate('/premium');
  };
  useEffect(() => {
     if (resetParcelSearchSignal === null) return;
  // Parent told us to close parcel search
  setShowParcelSearch(false);
  setParcelInput("");
  setParcelError("");
  setIsParcelValid(false);
  setIsParcelSearchActive(false);
}, [resetParcelSearchSignal]);

  useEffect(() => {
    if (activeTab === "all" && geocoderContainerRef.current) {
      if (
        geocoderContainerRef.current.childNodes.length === 0 &&
        window.geocoderInstance
      ) {
        geocoderContainerRef.current.appendChild(
          window.geocoderInstance.onAdd(window.initializedMap)
        );
      }
    }
  }, [activeTab, geocoderContainerRef]);

  const PARCEL_LENGTH_BY_COUNTY = {
  default: 7,
  wake: 10,
};
const getMinParcelLength = (county) => {
  if (!county) return PARCEL_LENGTH_BY_COUNTY.default;
  return PARCEL_LENGTH_BY_COUNTY[county.toLowerCase()] || PARCEL_LENGTH_BY_COUNTY.default;
};
const minLength = getMinParcelLength(selectedCounty);

const location = useLocation();
const isNCPage = location.pathname.toLowerCase().endsWith("/nc");
const isDashboardPage = location.pathname.toLowerCase().endsWith("/dashboard");


const isAdjacentParcels = location.pathname.endsWith("/GroupedParcels");
// Prefer controlled mode from parent when provided
const effectiveAdjacent = (typeof onAdjacentToggle === 'function' && typeof isAdjacentMode === 'boolean')
  ? isAdjacentMode
  : isAdjacentParcels;

const handleParcelViewToggle = (event) => {
  const checked = event.target.checked;

  // If parent provided a handler, use it and do NOT navigate
  if (typeof onAdjacentToggle === 'function') {
    onAdjacentToggle(checked);
    return;
  }

  // Fallback: maintain previous navigation behavior
  if (checked) {
    navigate("/GroupedParcels");
  } else {
    navigate("/nc");
  }
};


  return (
    <div className="headerTop">
      <div className="dflex subHeaderTop" style={
        showCountySelector ? {
          // Grid layout for NC component with county selector
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          gap: '20px'
        } : {
          // Original flex layout for dashboard and other pages
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }
      }>
        {/* FlowLogic Icon - LEFT */}
        <a href="/dashboard" style={{
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',
          zIndex: 10,
          textDecoration: 'none'
        }}>
          {/* <a href="/points"> */}
          <img
            className="logo"
            src="/assets/Flowlogic-Logo.svg"
            alt="FlowLogic Icon"
          />
          {/* <span style={{
            marginLeft: '8px',
            fontSize: '16px',
            fontWeight: '500',
            color: '#333'
          }}>
            -
            {isDashboardPage ? ' zipcode' : isNCPage ? ' parcels' : ''}
          </span> */}
        </a>

 


        {/* County Selector - CENTER (only shown in NC component) */}

        {showCountySelector && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              position: "relative",
            }}
          >
            {/* COUNTY DROPDOWN */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <style>
                {`
                .county-dropdown-header {
                  appearance: none;
                  -webkit-appearance: none;
                  -moz-appearance: none;
                }
                .county-dropdown-header option:checked {
                  background-color: #1c8f7d;
                  color: #fff;
                }
              `}
              </style>
              <select
                className="county-dropdown-header"
                value={selectedCounty}
                onChange={onCountyChange}
                style={{
                  width: "320px",
                  height: "40px",
                  padding: "0 40px 0 15px",
                  borderRadius: "28px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  fontSize: "14px",
                  background: "#fff url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"%23666\" d=\"M8 11L3 6h10z\"/%3E%3C/svg%3E') no-repeat right 15px center",
                  backgroundSize: "16px",
                  color: "#333",
                  cursor: "pointer",
                  fontWeight: 400,
                  boxShadow: "0 0 0 2px rgba(0,0,0,.1)",
                  outline: "none",
                  transition: "box-shadow 0.2s",
                }}
              >
                <option value="all">
                  All North Carolina
                </option>
                {countiesList.map(c => (
                  <option
                    key={c}
                    value={c.toLowerCase()}
                  >
                    {c}
                  </option>
                ))}
              </select>

             {/* PARCEL SEARCH placed immediately to the right of the county selector */}
             {showCountySelector && selectedCounty !== "all" && (
              //  <div style={{ position: 'absolute', left: '100%', top: '50%', transform: 'translate(8px, -50%)', display: 'flex', alignItems: 'center' }}>
                //  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '14px' }}>
                  <div style={{ position: 'absolute', left: 350, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                 <img
                   src="/assets/search.svg"
                   alt="Parcel search"
                   title="Parcel search"
                  //  style={{ width: 25, cursor: "pointer", opacity: showParcelSearch ? 1 : 0.7, marginRight: 6 }}
                    // style={{ width: 24, height: 24, cursor: "pointer", opacity: showParcelSearch ? 1 : 0.6, transition: 'opacity 0.2s' }}
                     style={{ width: 24, height: 24, cursor: "pointer", opacity: showParcelSearch ? 1 : 0.6, transition: 'opacity 0.2s', zIndex: 10 }}
                    onClick={() => {
                     setShowParcelSearch(!showParcelSearch);
                     setParcelInput("");
                     setParcelError("");
                     if (showParcelSearch) {
                       clearParcelSearch();
                       setIsParcelSearchActive(false);
                     }
                   }}
                 />

                 {showParcelSearch && (
                  //  <div style={{ background: "#fff", padding: 8, borderRadius: 6, boxShadow: "0 2px 8px rgba(0,0,0,0.2)", zIndex: 3000, width: 230 }}>
                    <div style={{ 
                    // position: 'absolute',
                    // left: 0,
                    // top: '50%',
                    // transform: 'translateY(-50%)',
                                    position: 'absolute',
                    right: '185%',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    marginRight: '8px',

                       width: "320px",
                  height: "40px",
                  padding: "0 40px 0 15px",
                  borderRadius: "28px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  fontSize: "14px",
                   fontWeight: 400,
                  boxShadow: "0 0 0 2px rgba(0,0,0,.1)",
                    
                    background: "#fff", 
                
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    zIndex: 3000, 
                    display: 'flex',
                    alignItems: 'center',
                     justifyContent: 'space-between',
                    gap: '8px'
                  }}>
                     {/* <div style={{ position: "relative" }}> */}
                       <div style={{ position: "relative", flex: 1 }}>
                       <input
                         type="text"
                         placeholder="Enter parcel #"
                         value={parcelInput}
                         maxLength={15}
                             autoFocus
                         onChange={(e) => {
                           const value = e.target.value.replace(/\D/g, "");
                           const currentLength = value.length;
                           setParcelInput(value);
                           prevLengthRef.current = currentLength;

                                      // if (prevLength >= minLength && currentLength < minLength) {
                          //   clearParcelSearch();
                          //   //  setIsParcelValid(false);
                          //   // setIsParcelSearchActive(false);
                          // }

                          if (currentLength === 0) {
                            setIsParcelValid(false);
                            setIsParcelSearchActive(false);
                            return;
                          }
                          
                           if (currentLength < minLength) {
                             setIsParcelValid(false);
                             return;
                           }
                          //  if (currentLength === minLength) {
                           setIsParcelValid(true);
                           setIsParcelSearchActive(true);
                           onParcelSearch(value);
                          //  }
                         }}
                        //  style={{ width: "100%", padding: "8px 30px 8px 10px", fontSize: 13, color: isParcelValid ? "#1c8f7d" : "#e53935", outline: "none" }}
                                           style={{ 
                          width: "100%", 
                          padding: "0 8px", 
                          fontSize: 13, 
                          color: isParcelValid ? "#1c8f7d" : (parcelInput.length > 0 && !isParcelValid ? "#e53935" : "#666"),
                          outline: "none",
                          border: 'none',
                          background: 'transparent',
                          fontWeight: 500
                        }}
                      />
                       {parcelInput.length > 0 && (
                         <button
                           type="button"
                           onClick={() => {
                             setParcelInput("");
                             setIsParcelValid(false);
                             setIsParcelSearchActive(false);
                             clearParcelSearch();
                           }}
                           title="Clear parcel search"
                          //  style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", border: "none", background: "transparent", cursor: "pointer", padding: 4 }}
                                                 style={{ 
                            position: "absolute", 
                            right: 0, 
                            top: "50%", 
                            transform: "translateY(-50%)", 
                            border: "none", 
                            background: "transparent", 
                            cursor: "pointer", 
                            padding: '4px 6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                           {/* <img src="/assets/close.svg" alt="Clear" style={{ width: 12, height: 12, opacity: 0.7 }} /> */}
                          <img src="/assets/close.svg" alt="Clear" style={{ width: 14, height: 14, opacity: 0.6 }} />
                         </button>
                       )}
                     </div>
                   </div>
                 )}
               </div>
             )}
              
            </div>

          </div>
        )}
        
        


        {/* Right Side Elements - RIGHT */}
        <div className="headerRightOuter" style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          justifySelf: 'flex-end',
          width: 'fit-content',
        }}>

                {/* Show only the opposite link */}
         {!isNCPage && (
           <button className="tab-button" type="button" onClick={() => navigate("/NC")} style={{ border: "1px solid #ddd", background: "transparent", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontSize: 13 }}>
             Parcels
           </button>
         )}
         {!isDashboardPage && (
           <button className="tab-button" type="button" onClick={() => navigate("/dashboard")} style={{ border: "1px solid #ddd", background: "transparent", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontSize: 13 }}>
             Dashboard
             {/* Zipcode  */}
           </button>
         )}
          <div class="headerMiddleOuter">
{/* PARCEL VIEW TOGGLE */}

 {/* {showCountySelector && selectedCounty !== "all" && (
<FormControlLabel
  control={
    <Switch
      checked={effectiveAdjacent}
      onChange={handleParcelViewToggle}
        sx={{
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#1C8F7D',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#1C8F7D',
    },
  }}
    />
  }
  label={
    <span style={{ fontSize: 13, fontWeight: 500 }}>
      {effectiveAdjacent ? "Parcels" : "Assembled Parcels"}
    </span>
  }
/>)} */}


{/* {showCountySelector && selectedCounty !== "all" && (
  <button
    onClick={() =>
      handleParcelViewToggle({ target: { checked: !effectiveAdjacent } })
    }
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      marginRight: "8px",
      borderRadius: "999px",
      fontSize: "13px",
      fontWeight: 500,
      fontFamily: "Manrope",
      // backgroundColor: effectiveAdjacent ? "#1C8F7D" : "#FFFFFF",
      // backgroundColor:"#FFFFFF",
       background: "transparent",
      // color: effectiveAdjacent ? "#FFFFFF" : "#040919",
      color:  "#040919",
      border: "1px solid #E7CCFF",
      cursor: "pointer",
      height: "32px",
      whiteSpace: "nowrap"
    }}
  >
    {effectiveAdjacent ? "Parcels" : "Assembled Parcels"}
  </button>
)} */}

{showCountySelector && selectedCounty !== "all" && (

  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "1px solid #E0E0E0",
      borderRadius: "999px",
      overflow: "hidden",
      marginRight: "8px",
      height: "32px",
    }}
  >
    <button
      onClick={() =>
        handleParcelViewToggle({ target: { checked: false } })
      }
      style={{
        padding: "6px 14px",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Manrope",
        background: !effectiveAdjacent ? "#1C8F7D" : "transparent",
        color: !effectiveAdjacent ? "#FFFFFF" : "#666",
        border: "none",
        cursor: "pointer",
        height: "100%",
        whiteSpace: "nowrap",
        transition: "all 0.2s",
      }}
    >
      Parcels
    </button>
    <button
      onClick={() =>
        handleParcelViewToggle({ target: { checked: true } })
      }
      style={{
        padding: "6px 14px",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Manrope",
        background: effectiveAdjacent ? "#1C8F7D" : "transparent",
        color: effectiveAdjacent ? "#FFFFFF" : "#666",
        border: "none",
        cursor: "pointer",
        height: "100%",
        whiteSpace: "nowrap",
        transition: "all 0.2s",
      }}
    >
      {/* Assembled Parcels */}
      Assemblage
    </button>
  </div>
)}


            {/*  PARCEL SEARCH */}
            {/* {showCountySelector && selectedCounty !== "all" && (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>

                <img
                  src="/assets/search.svg"
                  alt="Parcel search"
                  title="Search parcel"
                  style={{
                    width: 25,
                    cursor: "pointer",
                    opacity: showParcelSearch ? 1 : 0.7,
                    margin: 5
                  }}
                  onClick={() => {
                    setShowParcelSearch(!showParcelSearch);
                    setParcelInput("");
                    setParcelError("");
                    if (showParcelSearch) {
                      clearParcelSearch();
                      setIsParcelSearchActive(false);
                    }
                  }}
                />


                {showParcelSearch && (
                  <div
                    style={{
                      position: "absolute",
                      right: 28,               //  opens LEFT of icon
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "#fff",
                      padding: 8,
                      borderRadius: 6,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      zIndex: 3000,
                      width: 230,
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Enter parcel #"
                        value={parcelInput}
                        maxLength={15}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          const prevLength = prevLengthRef.current;
                          const currentLength = value.length;

                          setParcelInput(value);
                          prevLengthRef.current = currentLength;

                          // if (prevLength >= minLength && currentLength < minLength) {
                          //   clearParcelSearch();
                          //   //  setIsParcelValid(false);
                          //   // setIsParcelSearchActive(false);
                          // }

                          if (currentLength === 0) {
                            setIsParcelValid(false);
                            setIsParcelSearchActive(false);
                            return;
                          }

                          if (currentLength < minLength) {
                            setIsParcelValid(false);
                            return;
                          }

                          setIsParcelValid(true);
                          setIsParcelSearchActive(true);
                          onParcelSearch(value);
                        }}
                        style={{
                          width: "100%",
                          padding: "8px 30px 8px 10px",
                          fontSize: 13,
                          color: isParcelValid ? "#1c8f7d" : "#e53935",
                          outline: "none",
                        }}
                      />

                      {parcelInput.length > 0 && (


                        <button
                          type="button"
                          onClick={() => {
                            setParcelInput("");
                            setIsParcelValid(false);
                            setIsParcelSearchActive(false);
                            clearParcelSearch();
                          }}
                          title="Clear parcel search"
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="/assets/close.svg"   // or close.png
                            alt="Clear"
                            style={{
                              width: 12,
                              height: 12,
                              opacity: 0.7,
                            }}
                          />
                        </button>



                      )}
                    </div>
                  </div>
                )}
              </div>
            )} */}

            {showFavorites && (
              <a
                onClick={() =>
                  handleTabChange(activeTab === "favorites" ? "all" : "favorites")
                }
                className={`tab-button favorites ${activeTab === "favorites" ? "favorites-active" : ""
                  }`}
              >
                <img
                  src={
                    activeTab === "favorites"
                      ? "/assets/favorite.svg" // active icon
                      : "/assets/heart.svg" // inactive icon
                  }
                  alt="My favorites"
                />{" "}
                Favorites
              </a>
            )}

            <div className="iconGroup">
              {!isSubscribed && (
                <button className="upgrade-btn" onClick={handleUpgrade1}>
                  Upgrade
                </button>
              )}
            </div>

            {showLinks && (
              <div className="iconGroup">
                <Information /> {/* Information details */}
                <Feedback /> {/* Feedback form */}
              </div>
            )}

            <div className="profilePic">
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: '#1C8F7D',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 'bold',
                  userSelect: 'none',
                  cursor: 'pointer'
                }}
                aria-label="User Initial"
                title={storedEmail}
              >
                {storedName.charAt(0).toUpperCase()}
              </div>

            </div>

          </div>
          <UserMenu
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
            handleLogout={handleLogout}
          />
        </div>
      </div>


      {/* Search Box - Only if showSearch is true and showCountySelector is false */}
      {showSearch && !showCountySelector && activeTab !== "favorites" && (
        <div className="search">
          <div ref={geocoderContainerRef} className="geoCodeSerach"></div>
        </div>
      )}
    </div>
  );
}

export default Header;
